import { COMMON_WAIFUS, getCommonReviews } from '../../../constants.js';

export const ZH_BASE = {
    hero: {
      title: "Waifu Briscola",
      tagline: "前所未见的Briscola：RPG，Waifu和AI。",
      ctaWeb: "网页版游玩",
      ctaAndroid: "下载Android版",
      version: "版本 2.3",
      badge: "✨ 新地下城模式"
    },
    stats: {
      downloads: "下载量",
      downloadsValue: ["数不过来！", "服务器爆满", "一大堆！", "超过9000", "多到数不清"],
      hands: "输掉的手牌",
      handsValue: ["太多了...", "技术问题", "网络延迟", "这就哭了？", "再试一次，你会好运的"],
      rating: "评分",
      ratingValue: ["奶奶认可", "11/10 - IGN", "比披萨还好", "2026年度游戏", "绝对杰作"],
      waifus: "Waifu",
      waifusValue: ["全都是你的", "唯有2D > 3D", "收集她们！", "Waifu > 强度", "真正的宝藏"]
    },
    features: {
      title: "不仅仅是卡牌游戏",
      items: [
        { id: "classic", title: "经典Briscola", description: "原汁原味的体验，完美纯净。", icon: "🃏" },
        { id: "roguelike", title: "Roguelike RPG", description: "攀登高塔，获得元素力量并击败Boss。", icon: "⚔️" },
        { id: "ai", title: "鲜活AI", description: "多亏了Google Gemini，对手会实时辱骂或称赞你。", icon: "🧠" },
        { id: "gacha", title: "抽卡系统", description: "使用金币解锁新皮肤和稀有背景。", icon: "💎" },
        { id: "dungeon", title: "地下城模式", description: "面对规则疯狂的Boss。一次失败就结束。", icon: "🏰" },
        { id: "puzzle", title: "解谜模式", description: "完成特定目标的复杂场景。", icon: "🧩" }
      ]
    },
    video: { title: "游戏预告片" },
    waifus: {
      title: "选择你的伙伴",
      subtitle: "每个角色都有独特的性格、配音和游戏风格。",
      characters: [
        { ...COMMON_WAIFUS[0], name: "Miu", role: "甜美", personality: "甜美阳光，喜欢待在你身边。" },
        { ...COMMON_WAIFUS[1], name: "Rei", role: "分析师", personality: "精于计算且冷酷。只有逻辑。" },
        { ...COMMON_WAIFUS[2], name: "Akame", role: "傲娇", personality: "好胜且火爆。讨厌输。" },
        { ...COMMON_WAIFUS[3], name: "Lilith", role: "女王", personality: "卡牌的黑暗女王。" },
        { ...COMMON_WAIFUS[4], name: "Mochi", role: "向导", personality: "你值得信赖的向导...也许吧。" }
      ]
    },
    reviews: {
      title: "关于我们（遗憾的是）",
      items: getCommonReviews('zh')
    },
    ctaStrip: {
      title: "准备好上场了吗？",
      subtitle: "加入其他玩家，今天就开始你的冒险。",
      button: "立即开始游戏"
    },
    footer: { privacy: "隐私", terms: "条款", copyright: "© 2026 Waifu Briscola" },
    privacy: {
      title: "Waifu Briscola 隐私政策",
      lastUpdated: "最后更新：2024年5月25日",
      intro: "本隐私政策描述了当您使用Waifu Briscola应用程序（“服务”）时，您的信息是如何被管理的。",
      sections: [
        {
          title: "我们收集的信息",
          intro: "为了改善您的体验，我们使用可能收集信息的第三方服务：",
          items: [
            "使用数据 (PostHog)： 我们收集关于您如何与游戏互动的匿名或假名分析数据。这包括游戏开始、出牌和最终结果等事件。这些数据帮助我们了解游戏的使用情况以及如何改进它。我们不会通过PostHog收集个人身份信息 (PII)。",
            "AI互动 (Google Gemini)： 您发送的聊天消息和关于游戏状态的信息（如您手中的牌和桌上的牌）会被发送到Google Gemini API以生成AI的回复和动作。这些互动受Google隐私政策的约束。除了您的游戏互动内容外，我们不会向Google发送任何个人信息。",
          ],
        },
        {
          title: "我们如何使用您的信息",
          intro: "我们使用收集的信息用于：",
          items: [
            "提供、运营和维护我们的服务。",
            "改进、个性化和扩展我们的服务。",
            "了解和分析您如何使用我们的服务。",
            "防止滥用并确保安全。",
          ],
        },
        {
          title: "信息共享",
          body: "除非如上所述为了应用程序的运行而必需的第三方服务提供商（PostHog，Google），否则我们不会与任何人共享您的个人信息。",
        },
        {
          title: "数据安全",
          body: "您的信息安全对我们很重要，但请记住，没有任何互联网传输方法或电子存储方法是100%安全的。",
        },
        {
          title: "本隐私政策的变更",
          body: "我们可能会不时更新我们的隐私政策。我们将通过在此页面上发布新的隐私政策来通知您任何变更。",
        },
        {
          title: "联系我们",
          body: "如果您对本隐私政策有任何疑问，可以联系负责人Mauro Mazzocchetti。",
        },
      ],
    },
    consent: { text: "我们使用 Cookie 和分析数据来改进网站。继续使用即表示您接受我们的", ok: "知道了" },
    terms: {
      title: "Waifu Briscola 条款与条件",
      lastUpdated: "最后更新：2024年5月25日",
      contact: "负责人：Mauro Mazzocchetti",
      intro: "欢迎来到Waifu Briscola！这些条款和条件概述了使用Waifu Briscola应用程序（“服务”）的规则。",
      sections: [
        {
          title: "接受条款",
          body: "访问和使用此服务即表示您同意受这些条款的约束。如果您不同意条款的任何部分，则不得使用该服务。",
        },
        {
          title: "服务的使用",
          body: "您同意不将服务用于非法或未经授权的目的。您对自己的行为以及在使用服务期间提供的任何内容（包括聊天消息）负责。",
        },
        {
          title: "AI生成内容",
          intro: "本服务使用人工智能模型 (Google Gemini) 生成回复、评论和游戏动作。您承认：",
          items: [
            "AI生成内容由模型产生，可能并不总是准确、适当或一致。",
            "我们不对AI生成的内容负责。",
            "与AI的互动仅用于娱乐目的。",
          ],
        },
        {
          title: "责任限制",
          body: "在任何情况下，Mauro Mazzocchetti或其合作伙伴均不对任何间接、附带、特殊、后果性或惩罚性损害负责，包括但不限于因 (i) 您访问或使用或无法访问或使用服务；(ii) 从服务获得的任何内容而导致的利润损失、数据、商誉或其他无形损失。",
        },
        {
          title: "条款变更",
          body: "我们要保留随时自行决定修改或替换这些条款的权利。我们将通过在此页面上发布新条款来通知您任何变更。",
        },
        {
          title: "适用法律",
          body: "这些条款将受意大利法律管辖并按其解释，不考虑其法律冲突规定。",
        },
      ],
    }
};
